<template>
  <div class="termgenerator">
    <m-frame
      :routeList="menuList"
      alive-include="Home"
      title="积分充值"
      deletable
      deleteApi="/buypoints-front-removeApp.html"
      @delete="deleteApp"
    />
  </div>
</template>

<script>
import MFrame from '@/components/frame/Frame.vue';
export default {
  components: {
    'm-frame': MFrame,
  },
  setup() {
    const menuList = [
      {
        path: '',
        title: '操作指南',
      },
      {
        path: 'buy-points',
        title: '积分充值',
      },
      {
        path: 'selling-points',
        title: '售卖积分明细',
      },
    ];

    const deleteApp = async () => {};
    return {
      menuList,
      deleteApp,
    };
  },
};
</script>

<style lang="scss"></style>
